import React, { Component } from 'react';
import PropTypes from "prop-types";
import VisibilitySensor from "react-visibility-sensor";

class BannerTwo extends Component {
    render() {
        return (
            <>
                <div id="home" className="hompage-slides-wrapper">
                    <div className="single-slider-item slide-bg-1">
                        <div className="diplay-table">
                            <div className="display-table-cell">
                                <VisibilitySensor>
                                    {({ isVisible }) => (
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-lg-8">
                                                <span
                                                    className={
                                                        isVisible
                                                            ? "hero-text animated fadeInDown slow opacityOne"
                                                            : "opacityZero"
                                                    }
                                                >
                                                    {this.props.TopTitle}
                                                </span>

                                                <h1
                                                    className={
                                                        isVisible
                                                            ? "animated fadeInDown slow opacityOne"
                                                            : "opacityZero"
                                                    }
                                                >
                                                    {this.props.Title}
                                                </h1>
                                                <p
                                                    className={
                                                        isVisible
                                                            ? "animated fadeInDown slow opacityOne"
                                                            : "opacityZero"
                                                    }
                                                >
                                                    {this.props.Content}
                                                </p>
                                                <div className="center-wrap">
                                                    <div className="center-wrap">
                                                        <a href={this.props.BtnLink} className="btn-a">
                                                            <div className="button">
                                                                {this.props.BtnName}
                                                                <i className="icofont-long-arrow-right" />
                                                            <div className="mask" /></div>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                </VisibilitySensor>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
//Props Types
BannerTwo.propTypes = {
    TopTitle: PropTypes.string,
    Title: PropTypes.string,
    Content: PropTypes.string,
    BtnLink: PropTypes.string,
    BtnName: PropTypes.string,
};

//Default Props
BannerTwo.defaultProps = {
    TopTitle: "",
    Title: "Neninger Oriental Medicine",
    Content: "Making difference in the health of our patients",
    BtnLink:  "#contact",
    BtnName: "get started",
};

export default BannerTwo;
